import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ProviderNotesModel extends BaseModel {
  @attr("string") id;
  @attr("string") content;
  @attr("boolean") internalOnly;
  @attr("boolean") pinned;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("json") createdBy;
  @attr("json") updatedBy;
  @attr("json") readOnly;
}
